import { P, paletteHelper, typographyHelper } from '@property.com.au/ui-kit';
import styled, { css } from 'styled-components';

const selectedLabelStyles = css`
  ${typographyHelper('subtitle02')}
  color: ${paletteHelper('textInverted')};
`;

export const MediaGalleryTimelineLabel = styled(P)<{ $isSelected: boolean }>`
  ${typographyHelper('subtitle02')}
  color: ${paletteHelper('textSecondary')};

  ${({ $isSelected }) => ($isSelected ? selectedLabelStyles : null)};
`;
